/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Tlm_0Inputs */

const en_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manifest`)
};

const ar_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدليل`)
};

const bn_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manifest`)
};

const de_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest`)
};

const es_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manifiesto`)
};

const fr_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifeste`)
};

const pt_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manifesto`)
};

const zh_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清单`)
};

const tr_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bildirimi`)
};

const ru_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`манифест`)
};

const pl_svc_browser_extensions_tlm_0 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest`)
};

/**
* | output |
* | --- |
* | "manifest" |
*
* @param {Svc_Browser_Extensions_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_tlm_0 = /** @type {((inputs?: Svc_Browser_Extensions_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_tlm_0(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_tlm_0(inputs)
	if (locale === "de") return de_svc_browser_extensions_tlm_0(inputs)
	if (locale === "es") return es_svc_browser_extensions_tlm_0(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_tlm_0(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_tlm_0(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_tlm_0(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_tlm_0(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_tlm_0(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_tlm_0(inputs)
	return en_svc_browser_extensions_tlm_0(inputs)
});
export { svc_browser_extensions_tlm_0 as "svc_browser-extensions_tlm_0" }